import React from 'react';
import styled from '@emotion/styled';
import { BackgroundImageProps } from './background-image.props';

const Container = styled(({ imageSize, ...props }: BackgroundImageProps) => <div {...props} />)`
  position: relative;
  align-items: flex-end;
  z-index: 3;
  @media only screen and (min-width: 1600px) {
    width: ${props => props?.imageSize?.FullHD?.width};
    height: ${props => props?.imageSize?.FullHD?.height};
  }
  @media only screen and (min-width: 1280px) and (max-width: 1599px) {
    width: ${props => props?.imageSize?.MidHD?.width};
    height: ${props => props?.imageSize?.MidHD?.height};
  }
  @media only screen and (min-width: 1024px) and (max-width: 1279px) {
    width: ${props => props?.imageSize?.HD?.width};
    height: ${props => props?.imageSize?.HD?.height};
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    width: ${props => props?.imageSize?.TabletHor?.width};
    height: ${props => props?.imageSize?.TabletHor?.height};
  }
  @media only screen and (min-width: 640px) and (max-width: 767px) {
    width: ${props => props?.imageSize?.Tablet?.width};
    height: ${props => props?.imageSize?.Tablet?.height};
  }
  @media only screen and (min-width: 424px) and (max-width: 639px) {
    width: ${props => props?.imageSize?.MobileHor?.width};
    height: ${props => props?.imageSize?.MobileHor?.height};
  }
  width: ${props => props?.imageSize?.Mobile?.width};
  height: ${props => props?.imageSize?.Mobile?.height};
`;

const BackgroundImage = ({ children, imageSize }: BackgroundImageProps) => {
  return (
    <Container imageSize={imageSize}>
      {children}
    </Container>
  );
};

export default BackgroundImage;
